/**
 * Closing call-to-action band over a dignified, darkened image. Two clear next steps:
 * give, or get in touch via the enquiry form.
 */
import { ArrowRight, Mail } from 'lucide-react';
import { Button } from '../components/ui/Button.jsx';
import { img, MEDIA } from '../data/media.js';
import styles from './CtaBand.module.css';

export function CtaBand() {
  return (
    <section
      className={styles.band}
      style={{ '--bg': `url(${img(MEDIA.landscape, 1600)})` }}
    >
      <div className={styles.overlay} aria-hidden="true" />
      <div className={`container ${styles.inner}`}>
        <p className={styles.eyebrow}>Stand behind proven help</p>
        <h2 className={styles.title}>
          Rather verify than hope? <em>So would we.</em>
        </h2>
        <p className={styles.lede}>
          Fund a verified case, or reach out about volunteering and partnerships. Either way,
          you’ll be able to see exactly where your support lands.
        </p>
        <div className={styles.actions}>
          <Button to="/donate" variant="gold" size="lg" iconRight={ArrowRight}>
            Donate
          </Button>
          <Button to="/contact" variant="onDark" size="lg" iconLeft={Mail}>
            Get in touch
          </Button>
        </div>
      </div>
    </section>
  );
}

export default CtaBand;
